// @ts-check
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import PlainCountySelection from 'shared/components/PlainCountySelection';

const RawPlainCountySelection = wrapFormComponentWithLabelAndError(PlainCountySelection);
RawPlainCountySelection.displayName = 'RawPlainCountySelection';

const PlainCountySelectionField = connectFormComponentToReduxForm(RawPlainCountySelection);
PlainCountySelectionField.displayName = 'PlainCountySelectionField';

export default PlainCountySelectionField;

const PlainCountySelectionInput = connectFormComponentToReduxForm(
  wrapFormComponentWithError(PlainCountySelection)
);

export { PlainCountySelectionInput };
